var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiq-digital-resources"},[_c('SearchField'),_c('Filters'),_c('SearchSort'),_c('Message'),_c('ItemsBlock')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }